import { appConstants } from "../_constants";
import { appHelpers, authHeader, authFileHeader } from "../_helpers";

export const operationsService = {
    getFlightOperations,
    flightOperationsDownload,
    airlineOperationsDownload,
    flightsDownload,
    getPassengerLevelData,
    moreDetailManifestDownload
}

function getFlightOperations(payload) {
    return appHelpers
      .postRequest(
        `${appConstants.PAS_URL}/api/manifest/GetFlightOperations`,
        payload,
        authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res.data);
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      });
  }

  function flightOperationsDownload(payload, DownloadTypeId) {
    return appHelpers
      .postBinaryRequest(
        `${appConstants.PAS_URL}/api/Manifest/DownloadFlightOperations?DownloadTypeId=${DownloadTypeId}`, 
        payload,
        authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res);
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      });
  }  

  function moreDetailManifestDownload(manifestId) {
    return appHelpers
      .getBinaryRequest(
        `${appConstants.PAS_URL}/api/manifest/download?manifestid=${manifestId}`, 
        authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res);
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      });
  }

  function airlineOperationsDownload(payload) {
    return appHelpers
      .getBinaryRequest(
        `${appConstants.PAS_URL}/api/Manifest/DownloadAirlineData`, 
        payload,
        authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res); 
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      });
  }  

  function flightsDownload(payload) {
    return appHelpers
      .postBinaryRequest(
        `${appConstants.PAS_URL}/api/Manifest/DownloadFlightData`, 
        payload,
        authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res); 
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      });
  } 

  function getPassengerLevelData(payload) {
    return appHelpers
      .postRequest(
        `${appConstants.PAS_URL}/api/Iata/NewReport`, 
        payload,
        authHeader()
      )
      .then(res => {
        return appHelpers.formatPromiseResponse(res); 
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        return appHelpers.formatPromiseResponse(
          errorMessage,
          appConstants.ERROR_RESPONSE
        );
      });
  } 


// WEBPACK FOOTER //
// ./src/_services/operations.service.js